import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;
//获取品牌
export const getBrandList = (params={}) => {
    const url = adminApi  + 'OtaReport/brand'
    return http.fetchGet(url, params);
}
//获取品牌下的筛选项
export const getBrandFilter = (params={},res_params) => {
    const url = adminApi  + 'OtaReport/brandFilter';
    return http.fetchPost(url, params, res_params);
}
//获取ota时间轴
export const getOtaList = (params={},res_params) => {
    const url = adminApi  + 'OtaReport/otaList';
    return http.fetchPost(url, params, res_params);
}
//获取ota时间轴
export const getOtaDetail = (params={},res_params) => {
    const url = adminApi  + 'OtaReport/otaDetail';
    return http.fetchPost(url, params, res_params);
}

// OTA统计
export const getOtaIndexData = (params={},res_params) => {
    const url = adminApi + 'v2/ota/index';
    return http.fetchPost(url, params, res_params);
}
export const getOtaFuncData = (params={},res_params) => {
    const url = adminApi + 'v2/ota/func';
    return http.fetchPost(url, params, res_params);
}
export const getOtaFunc2Data = (params={},res_params) => {
    const url = adminApi + 'v2/ota/func2';
    return http.fetchPost(url, params, res_params);
}
export const getOtaFuncDetail = (params={},res_params) => {
    const url = adminApi + 'v2/ota/funcDetail';
    return http.fetchPost(url, params, res_params);
}
export const getOtaBrandData = (params={},res_params) => {
    const url = adminApi + 'v2/ota/brand';
    return http.fetchPost(url, params, res_params);
}
export const getOtaBrandDetail = (params={},res_params) => {
    const url = adminApi + 'v2/ota/brandDetail';
    return http.fetchPost(url, params, res_params);
}
export const getOtaYearData = (params={},res_params) => {
    const url = adminApi + 'v2/ota/year';
    return http.fetchPost(url, params, res_params);
}
export const getOtaKeywordDetail = (params={},res_params) => {
    const url = adminApi + 'v2/ota/keywordDetail';
    return http.fetchPost(url, params, res_params);
}

// OTA车型对比
export const getOtaBrandLetter = (params={}) => {
    const url = adminApi + 'v2/ota/brandLetter';
    return http.fetchGet(url, params);
}
export const getOtaModel = (params={},res_params) => {
    const url = adminApi + 'v2/ota/model';
    return http.fetchPost(url, params, res_params);
}
export const getOtaCompareDetail = (params={},res_params) => {
    const url = adminApi + 'v2/ota/compare';
    return http.fetchPost(url, params, res_params);
}
export const getOtaCompareDetailContent = (params={},res_params) => {
    const url = adminApi + 'v2/ota/compareDetail';
    return http.fetchPost(url, params, res_params);
}

// OTA品牌对比
export const getOtaBrand = (params={},res_params) => {
    const url = adminApi + 'v2/ota/brandList';
    return http.fetchPost(url, params, res_params);
}
export const getOtaBrandCompareDetail = (params={},res_params) => {
    const url = adminApi + 'v2/ota/compareBrand';
    return http.fetchPost(url, params, res_params);
}
export const getOtaBrandCompareDetailContent = (params={},res_params) => {
    const url = adminApi + 'v2/ota/compareBrandDetail';
    return http.fetchPost(url, params, res_params);
}

// OTA全局搜索
export const getOtaSearch = (params={},res_params) => {
    const url = adminApi + 'v2/ota/search';
    return http.fetchPost(url, params, res_params);
}
